const Backbone = require('backbone');
const Nunjucks = require('view');
const template = require('./item.twig');

const View = Backbone.View.extend({
	tagName: 'li',
	initialize: function() {
		var that = this;

		that.model.listenTo(that.model, 'change', that.render);
		that.model.listenTo(that.model, 'remove', function() {
			try {
				that.remove();
			} catch (e) {
				console.log(e);
			}
		});

		that.render();
	},
	render: function() {
		var that = this;

		var data = that.model.toJSON();

		that.$el.html(Nunjucks.renderString(template, data));
		
	}
});


module.exports = View;



//////////////////
// WEBPACK FOOTER
// ./views/kits/interna/item.js
// module id = 38
// module chunks = 0